import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface FactProps {
  label: string;
  children: ReactNode;
}

/** One label/value pair in a hover card. Every fact is the caller's choice. */
export const Fact = ({ label, children }: FactProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      gap: 2,
      py: 0.25,
    }}
  >
    <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
      {label}
    </Typography>
    <Typography
      component="div"
      variant="caption"
      sx={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}
    >
      {children}
    </Typography>
  </Box>
);
